import { ConsumptionModeListState } from 'redux/consumptionModeList';
import { ConsumptionModeType } from 'services/consumptionMode/consumptionMode.type';
import { Cart, ChannelId, OrderToCreate } from 'services/order/order.type';
import { PaymentMode } from './usePaymentVm';

export const DEFAULT_MINUTES_TO_ADD = 5;

export type GetPaymentMethodIdPayload = {
    paymentMode: PaymentMode;
    consumptionModeList: ConsumptionModeListState;
    currentConsumptionModeType: ConsumptionModeType | null;
};

export type ComputeCreateOrderPayload = {
    orderCart: Cart;
    restaurantId: number;
    currentMenuId: number;
    tableId: number;
    paymentMethodId: number;
    totalInclTax: number;
    stripePaymentMethodId: string;
};

export const getPaymentMethodId = ({
    paymentMode,
    consumptionModeList,
    currentConsumptionModeType,
}: GetPaymentMethodIdPayload): number | undefined => {
    const apiConsumptionMode = consumptionModeList.find(
        ({ type }) => type === currentConsumptionModeType,
    );

    const apiPaymentMethod = apiConsumptionMode?.paymentMethods.find(
        ({ code }) => code.toLocaleLowerCase() === paymentMode,
    );

    return apiPaymentMethod?.paymentMethodId;
};

export const computeExpectedAt = (today: Date, delayInMinutes = DEFAULT_MINUTES_TO_ADD): string =>
    new Date(today.setMinutes(today.getMinutes() + delayInMinutes)).toISOString();

export const computeCreateOrderPayload = ({
    orderCart,
    restaurantId,
    currentMenuId,
    tableId,
    paymentMethodId,
    totalInclTax,
    stripePaymentMethodId,
}: ComputeCreateOrderPayload): OrderToCreate => {
    const orderCartFormatted = orderCart.map((cartProduct) => ({
        productId: cartProduct.productId,
        quantity: cartProduct.quantity,
        steps: cartProduct.steps,
    }));

    return {
        restaurantId,
        channelId: ChannelId.WEB,
        consumptionMode: ConsumptionModeType.MODE_SIT_IN,
        menuId: currentMenuId,
        tableName: String(tableId),
        cart: orderCartFormatted,
        expectedAt: computeExpectedAt(new Date()),
        payments: [
            {
                paymentMethodId,
                amount: totalInclTax,
                quantity: 1,
                currency: 'EUR',
                metadata: `{"stripePaymentMethodId":"${stripePaymentMethodId}"}`,
            },
        ],
    };
};
